exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,\nhtml {\n  background-color: #333;\n  color: #ccc; }\n\na {\n  color: #ccc;\n  text-decoration: underline; }\n  a:hover {\n    color: #fff; }\n\nh1 {\n  margin-top: 0;\n  line-height: 32px; }\n\nh3 {\n  margin-top: 35px;\n  margin-bottom: 5px;\n  color: #5ac1e2;\n  font-size: 18px; }\n\np {\n  line-height: 1em; }\n\n.container {\n  width: 920px;\n  padding: 25px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./~/sass-loader!./src/styles.scss
// module id = 455
// module chunks = 2